var exports = {
  "container": "x8b4e8595--72590c--container",
  "container--size-m": "x8b4e8595--72590c--container--size-m",
  "container--size-s": "x8b4e8595--72590c--container--size-s",
  "container--active": "x8b4e8595--72590c--container--active",
};

module.exports = exports;
